import "./Switch.scss"

export const Switch = ({ status, setStatus, onClick }) => {
  const handleClick = () => {
    setStatus((c) => !c)
    if (typeof onClick === "function") onClick()
  }

  const cl = status ? "on" : ""

  return <div className={"switch " + cl} onClick={() => handleClick()}></div>
}
